<script lang="ts">
</script>
<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-40"></div>

        <h4 class="s7 font-semibold px-3 pb-5">Finance / Assets <span class="text-sm text-grey-500"></span></h4>
        <!-- <div class="s13 flex-right gap-3 mt--2 mb-5 px-5">
            <span class="btn shadow-200 white2">Wallet</span>
            <span class="btn shadow-200 white2">Gérer les prélèvements</span>
            <span class="btn shadow-200 light2 border-none">Prélèvements / Décaissements</span>
        </div> -->


        <div class="s20 flex gap-6">
            <div class="s10 widget flex flex-col align-items-center bg-gradient-dark h-100p px-6 pt-8 pb-6">
                <h1 class="font-normal text-grey-100 text-center py-1">
                    Wallet global
                </h1>
                <h1 class="font-bold text-white text-7xl text-center py-1">
                    450 000 000 F
                </h1>
                <div class="clear-both h-20"></div>

                <img src="/images/graph-transaction.png" alt="Transaction Graph" width="100%" />

                <div class="clear-both h-20"></div>

                <div class="s20 px-5 pt-4 rounded-100 mb-3" style="background-color: rgba(var(--color-white-rgb), 0.2);">
                    <!--Transaction - Component-->
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement de ma carte a partir de mon wallet</h6>
                            <p class="secondary-font text-sm text-grey-100 mb-2">12 Mars 2024 à 14:32 - TCE441454</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                    </div>
                    <!--End Transaction-->
                </div>
                <div class="s20 px-5 pt-4 rounded-100 mb-3" style="background-color: rgba(var(--color-white-rgb), 0.2);">
                    <!--Transaction - Component-->
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement de ma carte a partir de mon wallet</h6>
                            <p class="secondary-font text-sm text-grey-100 mb-2">12 Mars 2024 à 14:32 - TCE441454</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                    </div>
                    <!--End Transaction-->
                </div>
                <div class="s20 px-5 pt-4 rounded-100 mb-3" style="background-color: rgba(var(--color-white-rgb), 0.2);">
                    <!--Transaction - Component-->
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement de ma carte a partir de mon wallet</h6>
                            <p class="secondary-font text-sm text-grey-100 mb-2">12 Mars 2024 à 14:32 - TCE441454</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                    </div>
                    <!--End Transaction-->
                </div>

                <button class="btn lg mt-3 py-3 white2">
                    <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                    <span>Consulter</span>
                </button>
            </div>

            <div class="s10 widget flex flex-col align-items-center bg-gradient-dark h-100p px-6 pt-8 pb-6">
                <h1 class="font-normal text-grey-100 text-center py-1">
                    Fond de risque
                </h1>
                <h1 class="font-bold text-white text-6xl text-center py-1">
                    11 250 000 F
                </h1>
                <div class="clear-both h-20"></div>

                <img src="/images/graph-transaction.png" alt="Transaction Graph" width="100%" />

                <div class="clear-both h-20"></div>

                <div class="s20 px-5 pt-4 rounded-100 mb-3" style="background-color: rgba(var(--color-white-rgb), 0.2);">
                    <!--Transaction - Component-->
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement de ma carte a partir de mon wallet</h6>
                            <p class="secondary-font text-sm text-grey-100 mb-2">12 Mars 2024 à 14:32 - TCE441454</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                    </div>
                    <!--End Transaction-->
                </div>
                <div class="s20 px-5 pt-4 rounded-100 mb-3" style="background-color: rgba(var(--color-white-rgb), 0.2);">
                    <!--Transaction - Component-->
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement de ma carte a partir de mon wallet</h6>
                            <p class="secondary-font text-sm text-grey-100 mb-2">12 Mars 2024 à 14:32 - TCE441454</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                    </div>
                    <!--End Transaction-->
                </div>
                <div class="s20 px-5 pt-4 rounded-100 mb-3" style="background-color: rgba(var(--color-white-rgb), 0.2);">
                    <!--Transaction - Component-->
                    <div class="flex gap-6 mb-4">
                        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                            <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                        </div>
                        <div class="s13 mt-2">
                            <h6 class="secondary-font font-semibold mb-1">Rechargement de ma carte a partir de mon wallet</h6>
                            <p class="secondary-font text-sm text-grey-100 mb-2">12 Mars 2024 à 14:32 - TCE441454</p>
                        </div>
                        <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                    </div>
                    <!--End Transaction-->
                </div>

                <button class="btn lg mt-3 py-3 white2">
                    <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                    <span>Consulter</span>
                </button>
            </div>
        </div>


        <div class="clear-both h-20"></div>


        <div class="s20 widget align-items-center px-6 pt-8 pb-27">
            <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
                <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                    <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                    <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                    Données financières
                </span>
            </div>
            <div class="clear-both h-5"></div>

            <div class="s20 collapse-content pb-7 active">
                <div class="s7 px-8">
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Salaire <br class="mb-4"/>
                        <b class="text-3xl text-grey-800">350 000</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Prélèvement sur salaire <br class="mb-4"/>
                        <b class="text-3xl text-grey-800">25%</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Prêt en Concession<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">2 000 000</b>
                    </h4>
                </div>
                <div class="s6 px-8">
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Prélèvement à la Solde<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">64 000</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Pret à Rembourser<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">2 331 000</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Taux Interets Microfinance<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">8,5%</b>
                    </h4>
                </div>
                <div class="s7 px-8">
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Pouvoir Achat 1 An<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">1 300 000</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Pouvoir Achat 3 Ans<br class="mb-4"/>
                        <b class="text-3xl text-grey-800">4 300 000</b>
                    </h4>
                    <hr/>
                    <h4 class="font-normal text-grey-500 text-center py-3">
                        Durée Financement <br class="mb-4"/>
                        <b class="text-3xl text-grey-800">36 Mois</b> - <b class="text-3xl text-grey-800">3 ans</b>
                    </h4>
                </div>
            </div>
        </div>


        <div class="clear-both h-50"></div>

    </section>
</template>